// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { router } from "./router";
import axios from "axios";
import store from "@/store";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import vuetify from "./plugins/vuetify";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import VueUnits from "vue-units";
import "@fortawesome/fontawesome-free/css/all.css";
import VueStripeCheckout from "vue-stripe-checkout";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { api } from "@/api";
import {
  DatePicker,
  DecimalInput,
  Select,
  TimePicker,
  Prompt
} from "@/modules/Shared";
import { ProductRecipeLinkGrid } from "@/modules/Recipes/components";
import { RecipeProductEditor, RecipeEditor } from "@/modules/Recipes/views";
import { setPrivateInstanceHeader } from "@/api/configs";
import { round10 } from "round10";
import "./registerServiceWorker";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://d9e5ee32cfe94920aa15adc13e5dd5d1@sentry.io/1486232",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
}

moment.locale("fr-ca");

pdfMake.vfs = pdfFonts.pdfMake.vfs;
Vue.use(pdfMake);
Vue.use(pdfFonts);
Vue.use(moment);
Vue.use(require("vue-moment"));
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
});
Vue.use(VueUnits);

Vue.prototype.moment = moment;

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = "https://gesmintservice.com";
} else {
  axios.defaults.baseURL = "http://localhost:8000";
}

Vue.use(VueStripeCheckout, "pk_test_JmOqvNLQKODajox9gCVTqdb3");

Vue.component("j-date-picker", DatePicker);
Vue.component("j-time-picker", TimePicker);
Vue.component("j-decimal-input", DecimalInput);
Vue.component("j-select", Select);
Vue.component("Prompt", Prompt);
Vue.component("ProductRecipeLinkGrid", ProductRecipeLinkGrid);
Vue.component("RecipeProductEditor", RecipeProductEditor);
Vue.component("RecipeEditor", RecipeEditor);

if (store.getters.getAuthToken !== null) {
  setPrivateInstanceHeader(store.getters.getAuthToken);
}

Vue.filter("localFormat", function(date) {
  if (!date) return "";
  return moment(date).format("LLL");
});
Vue.filter("shortLocalFormat", function(date) {
  if (!date) return "";
  return moment(date).format("L");
});
Vue.filter("denseDateFormat", function(date) {
  if (!date) return "";
  return moment(date).format("YY/MM/DD");
});
Vue.filter("denseDateHourFormat", function(date) {
  if (!date) return "";
  return moment(date).format("MM/DD HH:mm");
});
Vue.filter("dateLocalFormat", function(date) {
  if (!date) return "";
  return moment(date).format("LL");
});
Vue.filter("round0", function(number) {
  return round10(number, 0);
});
Vue.filter("round2", function(number) {
  return round10(number, -2);
});
Vue.filter("round4", function(number) {
  return round10(number, -4);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>",
  vuetify,
  async created() {
    const routePath = this.$router.currentRoute.path;
    if (
      this.$store.getters.getIdToken !== null &&
      !routePath.includes("app") &&
      !routePath.includes("viewer")
    ) {
      try {
        this.$store.dispatch("slo");
        await api.verifyToken(this.$store.getters.getIdToken);
        this.$router.push({ name: "StatisticsIndex" });
        this.$store.dispatch("refreshToken");
      } catch {
        this.$store.dispatch("timeoutToken");
      } finally {
        this.$store.dispatch("elo");
      }
    }
  },
  async mounted() {
    setInterval(async () => {
      if (this.$store.getters.getIdToken !== null) {
        try {
          await api.verifyToken(this.$store.getters.getIdToken);
        } catch {
          this.$store.dispatch("timeoutToken").then(() => {});
        }
      }
    }, 18000000);
    let visibilityChange;
    if (typeof document.hidden !== "undefined") {
      visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      visibilityChange = "webkitvisibilitychange";
    }
    document.addEventListener(visibilityChange, () => this.timeout());
    document.addEventListener("mousemove", () => this.timeout());
  },
  data() {
    return {
      lastMove: 0
    };
  },
  methods: {
    async timeout() {
      if (Date.now() - this.lastMove > 3600000) {
        this.lastMove = Date.now();
        if (this.$store.getters.getIdToken !== null) {
          try {
            await api.verifyToken(this.$store.getters.getIdToken);
            this.$store.dispatch("refreshToken");
          } catch {
            this.$store.dispatch("timeoutToken");
          }
        }
      }
    }
  }
});
